import { lazy } from "react";

import { Navigate } from "react-router-dom";

import { RVNestedRoutingPage } from "@regal-voice/ui";
import { AppPagePaths } from "App/routes/paths";
import { SettingsPaths } from "Pages/settings/paths";

import { communicationTemplatesRoute } from "../CommunicationTemplates/Routes";
import { AgentDesktopPermissions } from "./AgentDesktopPermissions/AgentDesktopPermissions";
import { ADSettingsPaths } from "./paths";

import type { RegalRouteObject } from "App/routes/types";

const DispositionsPage = lazy(() => import("./Dispositions/DispositionsPage"));
const TagsPage = lazy(() => import("./Tags/TagsPage"));
const CancellationReasonsPage = lazy(() => import("./CancellationReasons/CancellationReasonsPage"));
const ActivityStatusesPage = lazy(() => import("./ActivityStatuses/ActivityStatusesPage"));
const AgentDesktopTaskPreferences = lazy(() => import("./TaskPreferences/TaskPreferences"));
const AgentDesktopPreferencesForm = lazy(() => import("./TaskPreferences/Pages/PreferencesForm/PreferencesForm"));

export const agentDesktopSettingsRoute: RegalRouteObject = {
    path: `${SettingsPaths.agentDesktop}/*`,
    element: <RVNestedRoutingPage />,
    hasNestedRoutes: true,
    children: [
        {
            index: true,
            element: (
                <Navigate
                    to={`${AppPagePaths.settings}/${SettingsPaths.agentDesktop}/${ADSettingsPaths.taskPreferences}`}
                    replace
                />
            ),
        },
        communicationTemplatesRoute,
        {
            path: ADSettingsPaths.dispositions,
            element: <DispositionsPage />,
        },
        {
            path: ADSettingsPaths.tags,
            element: <TagsPage />,
        },
        {
            path: ADSettingsPaths.cancellationReasons,
            element: <CancellationReasonsPage />,
        },
        {
            path: ADSettingsPaths.activityStatuses,
            element: <ActivityStatusesPage />,
        },
        {
            path: ADSettingsPaths.taskPreferencesForm,
            element: <AgentDesktopPreferencesForm />,
        },
        {
            path: ADSettingsPaths.taskPreferences,
            element: <AgentDesktopTaskPreferences />,
        },
        {
            path: ADSettingsPaths.agentPermissions,
            element: <AgentDesktopPermissions />,
        },
    ],
};
